var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPassword(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 18,
    viewBox: "0 0 14 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.1289 7.45312H1.58203C0.709664 7.45312 0 8.16279 0 9.03516V16.418C0 17.2903 0.709664 18 1.58203 18H12.1289C13.0013 18 13.7109 17.2903 13.7109 16.418V9.03516C13.7109 8.16279 13.0013 7.45312 12.1289 7.45312ZM6.85547 15.8906C6.56423 15.8906 6.32812 15.6545 6.32812 15.3633C6.32812 15.072 6.56423 14.8359 6.85547 14.8359C7.1467 14.8359 7.38281 15.072 7.38281 15.3633C7.38281 15.6545 7.1467 15.8906 6.85547 15.8906ZM7.79375 12.4186C7.53627 12.6081 7.38281 12.9109 7.38281 13.2292C7.38281 13.5207 7.14695 13.7689 6.85547 13.7689C6.56399 13.7689 6.32812 13.5454 6.32812 13.2539C6.32812 12.5773 6.64228 11.9567 7.16755 11.5694C7.30452 11.469 7.38281 11.3139 7.38281 11.1445C7.38281 10.8536 7.14593 10.6172 6.85547 10.6172C6.56501 10.6172 6.32812 10.8536 6.32812 11.1445C6.32812 11.436 6.09226 11.6719 5.80078 11.6719C5.5093 11.6719 5.27344 11.436 5.27344 11.1445C5.27344 10.2722 5.9831 9.5625 6.85547 9.5625C7.72784 9.5625 8.4375 10.2722 8.4375 11.1445C8.4375 11.6451 8.1965 12.1215 7.79375 12.4186Z",
    fill: "#FCFCFC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.27344 6.39844V4.74609C5.27344 3.87373 5.9831 3.16406 6.85547 3.16406C7.72784 3.16406 8.4375 3.87373 8.4375 4.74609V6.39844H11.6016V4.74609C11.6016 2.13071 9.47809 0 6.85547 0C4.23833 0 2.10938 2.12896 2.10938 4.74609V6.39844H5.27344Z",
    fill: "#FCFCFC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPassword);
export default __webpack_public_path__ + "static/media/password.b875ea5e6c0f63fcfdc6143583c7148b.svg";
export { ForwardRef as ReactComponent };